// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"HomeTitle-74dbef1e2d0f1f62"};